import { PreviewLifecycle } from './preview-lifecycle';
import { combinePreviewCache, mergePreviewResults } from './preview-cache';

interface GroupedTriangle {
  groupId?: number;
}

interface PreviewEntry<TTriangle extends GroupedTriangle> {
  triangles: TTriangle[];
  triangleCount: number;
  vertexCount: number;
  parts?: any;
  analysis?: any;
}

/** Owns preview request freshness and the incremental per-group geometry cache. */
export class PreviewController<TTriangle extends GroupedTriangle, TEntry extends PreviewEntry<TTriangle>> {
  private readonly lifecycle = new PreviewLifecycle();
  private readonly cache = new Map<number, TEntry>();

  public begin(): number { return this.lifecycle.begin(); }
  public isCurrent(generation: number): boolean { return this.lifecycle.isCurrent(generation); }
  public invalidate(): void { this.lifecycle.invalidate(); }
  public merge(results: readonly TEntry[]): void { mergePreviewResults(this.cache, results); }
  public combine(): TEntry { return combinePreviewCache(this.cache); }
  public getGroup(groupId: number): TEntry | undefined { return this.cache.get(groupId); }
  public getGroupIds(): number[] { return Array.from(this.cache.keys()); }
  public get size(): number { return this.cache.size; }
}
